import React from 'react'

const StoryOdysseyIconLight = () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5533_18196)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#11181C"/>
      <path d="M17.6205 14.4549C17.6205 17.572 15.1172 19.4455 12.0324 19.4455C8.94757 19.4455 6.79952 17.6043 6.39575 15.2463H9.23828C9.54515 16.1346 10.5626 16.7806 12.0324 16.7806C13.5021 16.7806 14.8264 15.957 14.8264 14.5034C14.8264 13.0498 13.6797 12.2907 12.0162 12.2907V14.3419C8.88297 14.3419 6.47651 12.5653 6.47651 9.57741C6.47651 6.58952 8.78606 4.57068 12.0324 4.57068C15.2787 4.57068 17.2329 6.41186 17.4429 8.65682H14.6972C14.4711 7.84928 13.5828 7.23555 12.097 7.23555C10.6111 7.23555 9.28673 8.07539 9.28673 9.49665C9.28673 10.9179 10.4334 11.6124 12.0162 11.6124V9.4482C15.424 9.4482 17.6205 11.4993 17.6205 14.4388V14.4549Z" fill="#FBFCFD"/>
    </g>
    <defs>
      <clipPath id="clip0_5533_18196">
        <rect width="24" height="24" rx="4" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)

export default StoryOdysseyIconLight
